import { ApiListStakeholdersResponse } from '../../../api/core/models';
import { BoardSettingsV2, STAKEHOLDER_TYPE } from '../model';

export function apiStakeholdersToStakeholders(
  stakeholdersResponse?: ApiListStakeholdersResponse
): BoardSettingsV2['stakeholders'] {
  if (!stakeholdersResponse?.stakeholders) {
    return undefined;
  }
  return stakeholdersResponse.stakeholders.map((apiStakeholder) => ({
    id: apiStakeholder.id as string,
    name: apiStakeholder.name,
    type: apiStakeholder.stakeholder as STAKEHOLDER_TYPE,
  }));
}
